var WhatsappTemplateBuilder = /** @class */ (function () {
    function WhatsappTemplateBuilder() {
        this.template = {
            id: 'templateId',
            name: 'out_of_hours',
            category: 5,
            locale: 'en',
            content: 'some content here',
            version: 1
        };
    }
    WhatsappTemplateBuilder.prototype.withId = function (id) {
        this.template.id = id;
        return this;
    };
    WhatsappTemplateBuilder.prototype.withName = function (name) {
        this.template.name = name;
        return this;
    };
    WhatsappTemplateBuilder.prototype.withCategory = function (category) {
        this.template.category = category;
        return this;
    };
    WhatsappTemplateBuilder.prototype.withLocale = function (locale) {
        this.template.locale = locale;
        return this;
    };
    WhatsappTemplateBuilder.prototype.withContent = function (content) {
        this.template.content = content;
        return this;
    };
    WhatsappTemplateBuilder.prototype.withVersion = function (version) {
        this.template.version = version;
        return this;
    };
    WhatsappTemplateBuilder.prototype.build = function () {
        return this.template;
    };
    return WhatsappTemplateBuilder;
}());
export { WhatsappTemplateBuilder };
//# sourceMappingURL=whatsapp-template.builder.js.map